/**
 * @param {{
 *   ProductUpdateExcelService: ReturnType<import('../../services/ProductUpdateExcelService').default>,
 * }} param0
 */
export default function productUpdateExcelUseCase({ ProductUpdateExcelService }) {
  const uploadFiles = ({ files }) => {
    const formData = new FormData();
    for (const file of files) {
      formData.append('file', file);
    }

    return ProductUpdateExcelService.uploadFiles(formData);
  };

  return {
    uploadFiles: uploadFiles,
  };
}
